import React, { useState } from 'react';
import LegalDocumentModal from '../TermsAndConditions/LegalDocumentModal';
import TermsOfService from '../../pages/main/TermsOfService';
import PrivacyPolicy from '../../pages/main/PrivacyPolicy';
import CookiePolicy from '../../pages/main/CookiePolicy';

const Footer = () => {
  const [openDoc, setOpenDoc] = useState(null);

  return (
    <footer className="bg-[#0f172a] px-4 py-8 text-white sm:px-6 md:px-16 md:py-10">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:gap-10 md:grid-cols-4">
        <div>
          <div className="mb-3 flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500 text-sm font-bold text-white md:text-lg">
              4
            </div>
            <span className="text-base font-bold md:text-lg">411 • Group</span>
          </div>
          <p className="text-sm text-gray-300">
            Empowering entrepreneurs from idea to impact through comprehensive training, coaching,
            and funding support.
          </p>
        </div>

        <div>
          <h3 className="mb-3 text-sm font-semibold text-white md:text-base">Programs</h3>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <a href="#" className="hover:text-white">
                Design-A-Business
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Business Acceleration
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Management Accounting
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Business Health Check
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold text-white md:text-base">Support</h3>
          <ul className="space-y-2 text-sm text-gray-400">
            <li>
              <a href="#" className="hover:text-white">
                Help Center
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Contact Us
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Community
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white">
                Resources
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="mb-3 text-sm font-semibold text-white md:text-base">Stay Updated</h3>
          <p className="mb-3 text-sm text-gray-400">
            Get the latest updates on programs and opportunities.
          </p>
          <form className="flex flex-col gap-2 sm:flex-row">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full rounded-md px-3 py-2 text-sm text-gray-800 outline-none sm:rounded-l-md sm:rounded-r-none"
            />
            <button
              type="submit"
              className="rounded-md bg-gradient-to-r from-blue-500 to-green-500 px-4 py-2 text-sm font-semibold text-white sm:rounded-l-none sm:rounded-r-md"
            >
              Subscribe
            </button>
          </form>
        </div>
      </div>
      <div className="mt-10 flex flex-col items-center justify-between border-t border-gray-700 pt-6 text-xs text-gray-400 sm:text-sm md:flex-row">
        <p>©2025 411 • Group. All rights reserved.</p>
        <div className="mt-4 flex gap-4 sm:gap-6 md:mt-0">
          <button onClick={() => setOpenDoc('privacy')} className="hover:text-white">
            Privacy Policy
          </button>
          <button onClick={() => setOpenDoc('terms')} className="hover:text-white">
            Terms of Service
          </button>
          <button onClick={() => setOpenDoc('cookies')} className="hover:text-white">
            Cookie Policy
          </button>
        </div>
      </div>

      <LegalDocumentModal
        isOpen={openDoc === 'terms'}
        title="Terms of Service"
        onClose={() => setOpenDoc(null)}
      >
        <TermsOfService />
      </LegalDocumentModal>

      <LegalDocumentModal
        isOpen={openDoc === 'privacy'}
        title="Privacy Policy"
        onClose={() => setOpenDoc(null)}
      >
        <PrivacyPolicy />
      </LegalDocumentModal>

      <LegalDocumentModal
        isOpen={openDoc === 'cookies'}
        title="Cookie Policy"
        onClose={() => setOpenDoc(null)}
      >
        <CookiePolicy />
      </LegalDocumentModal>
    </footer>
  );
};

export default Footer;
